import { useEffect, useState } from "react";
import { shouldShowInstallIntro } from "./pwa.ts";
import { useHelp } from "./help.ts";
import { useStore } from "./store.ts";
import { useInstallKind } from "./useInstall.ts";

/**
 * Whether the one-time install pop-up should be open now. Kept apart from the pop-up itself so the dialog's code is only
 * downloaded for the few players who will actually see it.
 */
export function useInstallIntroOpen(): boolean {
  const kind = useInstallKind();
  const seen = useStore((s) => s.installIntroSeen);
  const hasHistory = useStore((s) => s.seenIntro || Object.keys(s.stars).length > 0 || Object.keys(s.received).length > 0 || s.sent.length > 0);
  const eligible = shouldShowInstallIntro({ alreadySeen: seen, hasHistory, kind, userAgent: navigator.userAgent });
  // A beat after load, so it never fights the page appearing, and not on top of the help overlay.
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!eligible) return;
    const id = setTimeout(() => setReady(true), 1500);
    return () => clearTimeout(id);
  }, [eligible]);
  const helpOpen = useHelp((s) => s.open);
  return eligible && ready && !helpOpen;
}
